import { ReactNode } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";
import classNames from "classnames";

type LayoutSectionProps = {
  children: ReactNode;
  customClassName?: string;
};

const LayoutSection = ({ children, customClassName = "" }: LayoutSectionProps) => {
  const { projectClass } = useUiContext();

  const getClassName = () => classNames(`${projectClass}_LayoutSection`, customClassName);

  return <div className={getClassName()}>{children}</div>;
};

export default LayoutSection;
